<ngx-smart-modal #alertModal identifier="alertModal" customClass="nsm-dialog-animation-ttb medium-modal" (onAnyCloseEvent)="onAnyClose($event)">
  <h5 *ngIf="alertModal.hasData()" [innerHTML]="alertModal.getData().message">
  </h5>
</ngx-smart-modal>
